import {Inject, Injectable} from '@angular/core';

import { HttpClient } from '@angular/common/http';
// import { environment } from '../../environments/environment';
import { Observable } from 'rxjs/Observable';
import { CONFIG } from '../constants';

@Injectable()
export class ApiService {

    private baseUrl: string;
    private apiRoot: string;
    private http: HttpClient;

    constructor(http: HttpClient, @Inject(CONFIG) config) {
        this.http = http;
        const root = config.api_root;

        this.setBaseUrl(root);
        this.setApiRoot(root);
    }

    public setBaseUrl(url: string): void {
        this.baseUrl = url;
    }

    public getBaseUrl() {
        return this.baseUrl;
    }

    public setApiRoot(url: string): void {
        this.apiRoot = url;
    }

    public getaApiRoot() {
        return this.apiRoot;
    }

    private getUrl(uri) {
        return this.baseUrl + '/' + uri;
    }

    public get(uri, options = {}): Observable<any> {
        if(options != {}) {
            return this.http.get(this.getUrl(uri), options);
        }

        return this.http.get(this.getUrl(uri));
    }

    public post(uri, payload): any {
        return this.http.post(this.getUrl(uri), payload);
        // return this.makeRequest(uri, 'POST', body, options);
    }

    public put(uri, payload) {
        return this.http.put(this.getUrl(uri), payload);
        // return this.makeRequest(uri, 'PUT', body, options);
    }

    public delete(uri, options = {}) {
        return this.http.delete(this.getUrl(uri));
        // return this.makeRequest(uri, 'DELETE', null, options);
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/http/api.service.ts